import DE from './translations/de.json';
import TR from './translations/tr.json';
import EN from './translations/en.json';

export default {
    DE,
    TR,
    EN
};
